/**
 * 获取云处理结果
 * 任务创建、轮询
 */
import { fopCreate, fopQuery, type QueryRes } from '../services/index';
import { polling } from './polling';

// 轮询云处理任务
async function loopTaskStatus(taskId: string): Promise<QueryRes> {
    const result = await polling(
        // 异步任务
        async () => {
            const response = await fopQuery({ task_id: taskId });
            return response;
        },
        // 完成条件,2 成功、 3 失败
        (result: QueryRes) => {
            return result.status === 2 || result.status === 3;
        },
        // 配置选项
        {
            interval: 1000,
            timeout: 30 * 1000,
            onPolling: () => {
                // 轮询 `第 ${attempt} 次检查任务状态`
            },
        },
    );

    return result;
}

// 云处理 - 异步
export async function getFopsRes(obsURL: string, maatType: string, fops: string): Promise<QueryRes> {
    const { task_id } = await fopCreate({
        url: obsURL,
        save_type: maatType,
        fops,
    });
    return await loopTaskStatus(task_id);
}
